'use strict';

function Pay(
    $state,
    configs,
    $rootScope,
    $timeout,
    PortalApi,
    Authentication,
    $stateParams,
    uibDatepickerConfig,
    $location,
    $translate,
    Notification,
    Analytics,
    ClientCards,
    DateFormater,
    $anchorScroll,
    Localization,
    $q
) {
    var BigNumber = require('bignumber.js');
    var config = configs.payments_config;

    // 3DS polling limits, counted from confirm. Nothing waits on the user before
    // the challenge frame is up, so that wait is short; the challenge (OTP entry) is not.
    var SECURE3D_WAIT_LIMIT = 90 * 1000;
    var SECURE3D_CHALLENGE_LIMIT = 10 * 60 * 1000;
    var secure3dPoll = {
        timer: null,
        startedAt: 0
    };

    // Search check-step fields (including nested groups) for the receiver requisites (BANK_DETAILS) values
    function findBankDetails(fields) {
        if (!Array.isArray(fields)) {
            return null;
        }
        for (var i = 0; i < fields.length; i++) {
            var field = fields[i];
            if (field.type === 'BANK_DETAILS' && Array.isArray(field.values)) {
                return field.values;
            }
            if (field.type === 'GROUP' && Array.isArray(field.fields)) {
                var nested = findBankDetails(field.fields);
                if (nested) {
                    return nested;
                }
            }
        }
        return null;
    }

    function goToReceipt(paymentId) {
        if ($rootScope.servicePage) {
            return $state.go('pages.serviceReceipt', {
                payment_id: paymentId
            });
        }

        return $state.go('pages.receipt', {
            payment_id: paymentId,
            category_id: pay.data.searchServices.category,
            category_name: pay.data.categoryName,
            service_id: pay.data.searchServices.id,
            service_furl: pay.data.searchServices.furl
        });
    }

    function stopSecure3d() {
        $timeout.cancel(secure3dPoll.timer);
        secure3dPoll.timer = null;
        pay.secureCard = false;
        pay.methodStarted = false;
        $rootScope.$broadcast('stop3dSecure');
    }

    function secure3dTimedOut(paymentId) {
        stopSecure3d();
        pay.data.preLoader = true;

        $translate('NOTIFICATION.ERROR.SECURE3D_TIMEOUT').then(function (message) {
            Notification.error({
                message: message,
                delay: 10000
            });
        });

        return goToReceipt(paymentId);
    }

    function scheduleSecure3dCheck(paymentId, delay) {
        var limit = pay.secureCard ? SECURE3D_CHALLENGE_LIMIT : SECURE3D_WAIT_LIMIT;

        if (Date.now() - secure3dPoll.startedAt > limit) {
            return secure3dTimedOut(paymentId);
        }

        $timeout.cancel(secure3dPoll.timer);
        secure3dPoll.timer = $timeout(function () {
            secure3dPoll.timer = null;
            pay.secure3dcheck(paymentId);
        }, delay);

        return secure3dPoll.timer;
    }

    // The poll chain is not bound to any scope: drop it when the user leaves the page.
    $rootScope.$on('$stateChangeStart', stopSecure3d);

    var pay = {
        data: {
            bookingStart: null,
            checkMask: {
                changeForMask: false,
                fields: []
            },
            twoStepCreateForm: {},
            preLoader: true,
            comboLoader: false,
            mpPreLoader: false,
            hideEditBtn: false,
            createTemplate: false,
            redirect: false,
            counterOfAutocheck: 0,
            showBlock: '',
            getService:{
                fields:[]
            },
            tickets: {
                start: false
            }
        },
        obj: {},
        options: {},
        amount: 0,
        amountWithCommission: 0,
        oldAmountInput: 0,
        amountInput: 0,
        amountInputRO: false,
        autoCheck: false,
        amountMin: 0,
        commission: 0,
        commissionDescription: '',
        commissionHavePrepaid: false,
        commissions: [],
        discount: 0,
        destinationTemplate: '',
        testTemplate: '',
        templateId: 0,
        fields: [],
        forFrame: {},
        forms: {},
        selectedProduct: [],
        selectedFieldsOnCheck: {},
        checkFields: [],
        createFields: [],
        queryFields: [],
        createData: {},
        selectedGroup: {
            check: [],
            create: []
        },
        payment: {},
        scrollTop: false,
        service: {},
        subsidyObj: {},
        subsidy: 0,
        info: {},
        user: Authentication.user,
        innerState: '',
        isOpenDropCard: true,
        card: {
            number: {
                value: '',
                focusIn: false
            },
            month: {
                value: '',
                focusIn: false
            },
            year: {
                value: '',
                focusIn: false
            },
            cvv: {
                value: '',
                focusIn: false,
                isShowPopupCvv: false
            },
            cardId: 0,
            keyDown: function (eventSelected, inputField) {
                switch (inputField) {
                    case 'month':
                        if (pay.card.month.value.length == 2) {
                            pay.card.year.focusIn = true;
                        }
                        break;
                    case 'year':
                        if (pay.card.year.value.length == 2) {
                            pay.card.cvv.focusIn = true;
                        }
                        break;
                    default:
                        break;
                }
            }
        },
        secureCard: false,
        methodStarted: false,
        agreement: {
            value: false
        },
        selectedPhone: {
            phone: '',
            code: '',
            number: '',
            operator: {}
        },

        setCard: function (number) {
            pay.card.number.value = number;
            pay.isOpenDropCard = !pay.isOpenDropCard;
        },
        init: function () {
            // $rootScope.servicePage = $state.current.name == 'pages.service';
            // $rootScope.yasno = $state.current.name == 'pages.yasno' || $state.current.name == 'pages.yasnoP2P';

            pay.amount = 0;
            pay.amountInput = 0;
            pay.amountWithCommission = 0;
            pay.commission = 0;
            pay.data.checkMask.changeForMask = false;
            pay.amountInputRO = false;

            ClientCards.clearCardFields();
            ClientCards.mpCommission = false;

            $rootScope.$broadcast('Pay.init');

            // if($state.current.name.replace('pages.', '') == 'p2p') {
            //     pay.data.p2p = true;
            // }

            if (Authentication.isLogged && !$stateParams.templateId) {
                pay.data.createTemplate = true;//todo scope
            }

            if ($stateParams.templateId) {
                pay.templateId = $stateParams.templateId;
                pay.amount = pay.amountInput = $stateParams.amount;
            }
            // if ($stateParams.hhTemplate) {
            //     pay.amount = pay.amountInput = $stateParams.amount;
            // }
            if (
                $stateParams.notify &&
                $stateParams.notify.mssg &&
                $stateParams.notify.type == 'ERRORS'
            ) {
                $translate(JSON.stringify($stateParams.notify.mssg)).then(function(message) {
                    Notification.error({
                        message: message,
                        delay: 5000
                    });
                }, function (err) {
                    $translate('NOTIFICATION.ERROR.UNKNOWN_ERROR').then(function(message) {
                        Notification.error({
                            message: message,
                            delay: 5000
                        });
                    });
                });
            }

            if ($stateParams.editForbid) {
                pay.data.hideEditBtn = true;
            }

            if ($stateParams.destination &&
                pay.service.destination_editable &&
                pay.service.destination_visible
            ) {
                pay.service.destination = $stateParams.destination;
            }

            pay.checkFields = [];
            pay.payment = {};
            pay.secureCard = false;
            pay.methodStarted = false;
            pay.obj = {};
            pay.service.destinationTemplate = pay.service.destination ? pay.service.destination : '';

            var regExp = /([\w\d_-])+(?=}})/g;
            var serviceFieldsNames = pay.service.destinationTemplate.match(regExp);

            if (serviceFieldsNames && serviceFieldsNames.length) {
                serviceFieldsNames.forEach(function (item) {
                    pay.obj[item] = '';
                });
            }

            if ($stateParams.fields && Array.isArray(pay.fields)) {
                pay.fields.forEach(function (field, index) {
                    if (Array.isArray($stateParams.fields)) {
                        $stateParams.fields.forEach(function (param_field) {
                            if(param_field.name == field.name){
                                field.value = param_field.value;
                            }
                        });
                    } else {
                        if ($stateParams.fields[field.name] || $stateParams.fields[field.alias]) {
                            pay.fields[index].value = $stateParams.fields[field.name] ? $stateParams.fields[field.name].value : $stateParams.fields[field.alias].value;
                        } else if ($stateParams.fields[field.id]) {
                            pay.fields[index].value = $stateParams.fields[field.id];
                        }
                    }
                });
            }

            pay.fields.forEach(function (field) {
                var tmpField;
                var groupFields = [];

                if (field.type == 'GROUP') {
                    groupFields = field.fields;
                    field.fields.forEach(function (f) {
                        if (f.template &&
                            (f.type === 'PERIOD' || f.type === 'DATE')
                        ) {
                            tmpField = f;
                            f.template = f.template.replace(/[m]/g, 'M');
                            f.template = f.template.replace(/[D]/g, 'd');
                            f.template = f.template.replace(/[Y]/g, 'y');
                        }
                    });
                } else if (field.template &&
                    (field.type === 'PERIOD' || field.type === 'DATE')
                ) {
                    tmpField = field;
                    field.template = field.template.replace(/[m]/g, 'M');
                    field.template = field.template.replace(/[D]/g, 'd');
                    field.template = field.template.replace(/[Y]/g, 'y');
                }

                /*date picker template options*/
                if (tmpField) {
                    if (tmpField.type === 'DATE') {
                        if (!tmpField.template || tmpField.template.indexOf('dd') !== -1) {
                            pay.data.dateOptions = {//todo scope
                                minMode: 'day'
                            };
                            pay.data.dateMode = 'day';//todo scope
                        }
                        else {
                            pay.data.dateOptions = {//todo scope
                                minMode: 'month'
                            };
                            pay.data.dateMode = 'month';//todo scope
                        }
                    }

                    if (tmpField.type === 'PERIOD') {
                        if (!tmpField.template || tmpField.template.indexOf('dd') !== -1) {
                            pay.data.periodOptions = {//todo scope
                                minMode: 'day'
                            };
                            pay.data.periodMode = 'day';//todo scope
                        }
                        else {
                            pay.data.periodOptions = {//todo scope
                                minMode: 'month'
                            };
                            pay.data.periodMode = 'month';//todo scope
                        }

                        if (tmpField.alias) {
                            var fields = groupFields.length ? groupFields : pay.fields;
                            switch (tmpField.alias) {
                                case 'PERIOD_END':
                                    var periodStart = fields.find(function (field) {
                                        return field.alias == 'PERIOD_START';
                                    });

                                    tmpField.periodOptions = {
                                        minMode: 'day',
                                        minDate: periodStart.value
                                    };

                                    break;

                                case 'PERIOD_START':
                                    var periodEnd = fields.find(function (field) {
                                        return field.alias == 'PERIOD_END';
                                    });

                                    tmpField.periodOptions = {
                                        minMode: 'day',
                                        maxDate: periodEnd.value
                                    };

                                    break;

                                default:
                                    break;
                            }
                        }
                    }
                }
                /*date picker template options*/

                /*field mask*/
                if (field.type == 'mobnumber') {
                    field.hint = '+38 (___) ___-__-__';
                    field.mask = '+38 (999) 999 99 99';
                }
                if (field.type == 'customeraccount') {
                    field.hint = '2625__________';
                    field.mask = '26259999999999';
                }
                if (field.type == 'accountnumbers') {
                    field.regex = '^[0-9]{1,}$';
                }
                /*end field mask*/

            });

            uibDatepickerConfig.showWeeks = false;
            //  END DatePicker options

            if ($stateParams.amount) {
                // pay.amountInput = pay.amount = $stateParams.amount;
                pay.amountInput = $stateParams.amount;
                ClientCards.data.amount = pay.amount;

            } else if ($location.search().length > 0 || Object.keys($location.search()).length > 0) {
                var obj = $location.search();

                for (var key in obj) {
                    if (Array.isArray(obj[key])) {
                        var el= obj[key];
                        obj[key] = el[0]                        
                    }
                }                

                pay.fields.forEach(function (item) {
                    if (obj[item.alias]) {
                        if (item.type == 'SELECT') {
                            for (var i = 0; i < item.values.length; i++) {
                                if (item.values[i].id == obj[item.alias]) {
                                    item.value = item.values[i].id;
                                }
                            }
                        } else {
                            item.value = decodeURIComponent(obj[item.alias]);
                        }
                    }
                });

                // if(Pay.data.getService.service.redirect_from_id){
                //     $stateParams.serviceId = Pay.data.getService.service.id;
                //     $stateParams.url = Pay.data.getService.service.furl;
                //     $stateParams.destination = Pay.data.getService.service.destination;
                //
                //     var obj = $location.search();
                //
                //     if ($location.search().length > 0 || Object.keys($location.search()).length > 0) {
                //         Pay.data.getService.fields.forEach(function (item) {
                //             if (obj[item.name]) {
                //                 item.value = decodeURIComponent(obj[item.name]);
                //             }
                //         });
                //         $stateParams.fields = Pay.data.getService.fields;
                //     }
                //
                //     $state.go('pages.payment', {
                //         serviceId: $stateParams.serviceId,
                //         url: $stateParams.url,
                //         fields: $stateParams.fields,
                //         autoCheck: false,
                //         templateId: false,
                //         destination: $stateParams.destination
                //     });
                // }

                // pay.forFrame = obj;

                if (obj.amount) {
                    pay.amountInput = $stateParams.amount = new BigNumber(obj.amount).dividedBy(100).toFixed(2);
                    ClientCards.data.amount = pay.amount;
                    // pay.amountInput = pay.amount = new BigNumber(obj.amount).dividedBy(100).toFixed(2);
                    // pay.amountInput = new BigNumber(obj.amount).dividedBy(100).toFixed(2);
                }

                if (obj.cardTo) {
                    ClientCards.data.target.card = obj.cardTo;
                }
                if (obj.partner_id) {
                    pay.partner_id = obj.partner_id;
                }

                if (obj.autoCheck && pay.data.counterOfAutocheck < 1) {//todo scope counterOfAutocheck
                    $stateParams.autoCheck = true;
                }
            }

            $rootScope.$broadcast('countAmount');

            pay.changeInnerState('check');

            if ($stateParams.autoCheck) {
                // Save original fields for service_id 13055 before mask
                if ($rootScope.useFrame && pay.service.id == 13055 && !pay.data.checkMask.changeForMask) {
                    pay.data.checkMask.fields = angular.copy(pay.fields);
                    pay.data.checkMask.changeForMask = true;
                }

                if ($stateParams.hh.templateId) {
                    pay.fields.forEach(function (field) {
                        if (field.name == "streetName") {
                            field.value = $stateParams.hh.streetName;
                        }

                        if (field.name == "street") {
                            field.value = $stateParams.fields.streetId.value;
                        }

                        if (field.name == "building") {
                            field.value = $stateParams.fields.house.value + '';
                        }

                        if (field.name == "appartment") {
                            field.value = $stateParams.fields.appartment.value + '';
                        }
                    });

                    pay.selectedProduct.serviceName = $stateParams.hh.serviceName;
                }

                pay.checkPayment();
            } else {
                pay.data.preLoader = false;
            }
        },
        changeInnerState: function (state) {
            pay.innerState = state;
        },

        submitForm: function (data) {//TODO: is this need?
            pay[pay.form.innerState + 'Payment'](data);
        },
        /*confirm for service(frame) page*/
        confirmServicePayment: function () {
            pay.data.preLoader = true;

            if ($stateParams.autoCheck && !pay.data.searchServices.two_step) {
                return pay.confirmPayment(false);
            }

            if (pay.data.searchServices.two_step) {
                pay.createPayment(true);
            } else if (!pay.data.searchServices.two_step) {
                pay.checkPayment(true);
            }
        },
        /*end confirm for service(frame) page*/
        // bank_details_promise: function (data) {            
        //     return $q(function(resolve, reject) {
        //         if (data && data.length > 0) {
        //             data.forEach(function (group) {
        //                 if (group.type == 'GROUP') {
        //                     if (group.fields && group.fields.length > 0) {
        //                         group.fields.forEach(function (field) {
        //                             if (field.type == 'BANK_DETAILS') {
        //                                 field.restriction = 'RO';
        //                             }
        //                         })
        //                     }
        //                 } else {
        //                     if (group.type == 'BANK_DETAILS') {
        //                         group.restriction = 'RO';
        //                     }
        //                 }
        //             })
        //             resolve(data);
        //         } else {
        //             reject(data);
        //           }
        //       });
        // },
        checkPayment: function (step) {
            pay.selectedGroup.create = [];

            //for template
            if ($stateParams.templateId && $stateParams.autoCheck) {
                for (var key in $stateParams.fields) {
                    for (var i = 0; i < pay.fields.length; i++) {
                        if (pay.fields[i].alias == key) {
                            pay.fields[i].value = $stateParams.fields[key].value;
                        }
                    }
                }
            }

            //
            //Mask for check input fields service_id 13055, and iframe = true  or page url = service
            if (pay.service.id == 13055) {
                if ($rootScope.useFrame || $state.current.name == 'pages.service') {
                    if (!pay.data.checkMask.changeForMask) {
                        pay.data.checkMask.fields = angular.copy(pay.fields);
                        pay.data.checkMask.changeForMask = true;
                    }
                    pay.fields.forEach(function (field) {
                        // var accTemp = '';
                        var innTemp = '';
                        var l = 0;
                        if (field.alias == "account") {
                            /*l = field.value.length;
                            accTemp = field.value.slice(-4);
                            field.value = field.value.slice(0, 4);
                            for (var i = 0; i < l-8; i++) {
                                field.value +="*"
                            }*/
                            field.value = field.value.slice(0, 4) + '**' + field.value.slice(-4);
                        }
                        if (field.alias == "inn") {
                            l = field.value.length;
                            innTemp = field.value.slice(-2);
                            field.value = field.value.slice(0, 2);
                            for (var i = 0; i < l-4; i++) {
                                field.value +="*"
                            }
                            field.value += innTemp;
                        }
                    });
                }
            }
            //finish mask

            // $rootScope.$broadcast('Pay.check');
            if (step == true) {
                pay.data.load = 'stepOne';
            }

            pay.data.load = null;
            pay.data.preLoader = true;

            pay.service.destination = pay.destinationTemplate;
            pay.payment.order_id = +new Date();
            pay.payment.service_id = pay.data.serviceId;

            if (!pay.service.use_two_step) {
                pay.amount = pay.amountWithCommission;
            }

            ClientCards.data.amount = pay.amount;

            pay.fields.forEach(function (field) {

                if (field.regex) {
                    field.validation = field.regex;
                }

                switch (field.type) {
                    case 'PERIOD':
                    case 'DATE':
                        if ($stateParams.lastDate) {
                            DateFormater.data.originDate = $stateParams.lastDate;
                        } else {
                            DateFormater.data.originDate = field.value;
                        }
                        break;
                    case 'number':
                        parseInt(field.value);
                        break;
                    case 'text':
                        if ($stateParams.account) {
                            field.value = $stateParams.account;
                        }

                        if (field.value) {
                            field.value.toString();
                        }
                        break;
                }
            });

            // if($stateParams.autoCheck) {
            //     pay.autoCheck = true;
            //     $stateParams.autoCheck = false;
            // }

            PortalApi.checkPayment(pay).then(function (response) {
                if (response.status != 'ok') {
                    DateFormater.returnOriginDate();
                    pay.data.preLoader = false;

                    if (/^[A-Z_]+$/.test(response.data)) {
                        return $translate('ERRORS.' + response.data)
                            .then(
                                function(errMsg) {
                                    pay.apiError(errMsg, 10);
                                },
                                function () {
                                    $translate('NOTIFICATION.ERROR.CHECK_PAYMENT_ERROR').then(function(errMsg) {
                                        pay.apiError(errMsg, 10);
                                    });
                                }
                            );
                    } else {
                        return $translate('NOTIFICATION.ERROR.CHECK_PAYMENT_ERROR').then(function(errMsg) {
                            pay.apiError(errMsg, 10);
                        });
                    }
                }

                if (typeof $stateParams.hh == 'object' &&
                    $stateParams.hh.serviceName &&
                    pay.service.use_two_step &&
                    Array.isArray(response.data)
                ) {
                    var HHpr = response.data.find(function (product) {
                        return product.serviceName == $stateParams.hh.serviceName;
                    });

                    if (HHpr) {
                        response.data = [HHpr];
                    }
                }

                pay.payment.id = response.id;
                
                // For old services, BANK_DATAILS field make visible
                // pay.bank_details_promise(response.data).then(function(res) {
                //     pay.checkFields = res;
                // });
                
                if (response.data && response.data.length > 0) {
                    response.data.forEach(function (group) {
                        if (group.type == 'GROUP') {
                            if (group.fields && group.fields.length > 0) {
                                group.fields.forEach(function (field) {
                                    if (field.type == 'BANK_DETAILS') {
                                        field.restriction = 'RO';
                                    }
                                    if (group.template && (group.type === 'PERIOD' || group.type === 'DATE') ) {
                                        group.template = group.template.replace(/[m]/g, 'M');
                                        group.template = group.template.replace(/[D]/g, 'd');
                                        group.template = group.template.replace(/[Y]/g, 'y');
                                    }
                                })
                            }
                        } else {
                            if (group.template && (group.type === 'PERIOD' || group.type === 'DATE') ) {
                                group.template = group.template.replace(/[m]/g, 'M');
                                group.template = group.template.replace(/[D]/g, 'd');
                                group.template = group.template.replace(/[Y]/g, 'y');
                            }

                            if (group.type == 'BANK_DETAILS') {
                                group.restriction = 'RO';
                            }

                            if (group.type == 'AMOUNT' &&
                                group.alias === 'TOTAL_AMOUNT' &&
                                group.value &&
                                group.restriction === 'RO' &&
                                group.value/100 >= pay.service.amount_min &&
                                group.value/100 <= pay.service.amount_max
                            ) {
                                pay.amount = pay.amountInput = (group.value/100).toString();
                                pay.amountInputRO = true;

                                $rootScope.$broadcast('countAmount');
                            }

                            if (group.alias === 'TOTAL_AMOUNT' && group.value && !$stateParams.amount) {
                                pay.amount = group.value / 100;
                                pay.amountInput = group.value / 100;

                                $rootScope.$broadcast('countAmount');
                            }
                        }
                    })
                }
                // remove timeout when fix bank_datails restriction
                $timeout(function() {
                    pay.checkFields = response.data;
                })

                pay.utilitiesForm = {
                    data: response.data,
                    id: response.id,
                    status: response.status
                };

                // Mask after check step for personal data, service_id=13055, and iframe = true or page url = service
                if (pay.service.id == 13055) {

                    if ($rootScope.useFrame || $state.current.name == 'pages.service') {
                        pay.checkFields.forEach(function (field) {
                            var sp = [];
                                if (field.alias == "DOP_INFO_1") {
                                    sp = field.value.split(" ");
                                    field.value = '';
                                    for (var j = 0; j < sp.length; j++) {
                                        var tmp = sp[j];
                                        sp[j] = '';

                                        if (tmp.length > 4) {
                                            for (var k = 0; k < 4; k++) {
                                                sp[j] += tmp[k]
                                            }
                                        } else if (2 < tmp.length < 5) {
                                            for (var k = 0; k < 2; k++) {
                                                sp[j] += tmp[k]
                                            }
                                        }
                                        sp[j] += "**";

                                        field.value += sp[j];
                                        if (i + 1 < sp.length) {
                                            field.value += " ";
                                        }
                                    }
                                }
                        });
                    };
                }
                // finish mask

                // if ($stateParams.hhTemplate) {
                //     return pay.addNewServiceHH(response);
                // }

                //remove when fix bank_details
                if (!pay.service.use_two_step) {
                    return $timeout(function(){
                        pay.createPayment(step);
                    })
                }

                if (Array.isArray(pay.checkFields) && pay.checkFields.length) {
                    pay.checkFields.forEach(function (field) {
                        if (field.type == 'AMOUNT' && !$stateParams.autoCheck) {
                            pay.amount = pay.amountInput = field.value/100;
                        }
                        if (Array.isArray(field.meters) && field.meters.length) {
                            field.meters.forEach(function (meters) {
                                if (typeof meters.previous == "string") {
                                    meters.previous = parseFloat(meters.previous);
                                }
                                if (meters.previous == 0) {
                                    meters.current = 0;
                                }
                                if (meters.current == 0) {
                                    meters.current = meters.previous;
                                }
                                if (!meters.Tariff) {
                                    meters.Tariff = 0;
                                }
                                meters.difference = 0;
                            });
                        }
                    });
                }

                pay.data.twoStepCreateForm.$dirty = false;

                if (pay.service.use_two_step) {
                    for (var i = 0; i < pay.checkFields.length; i++) {
                        if (pay.checkFields[i].selected && pay.checkFields[i].amountType > 0) {
                            pay.checkFields[i].minAmount = pay.checkFields[i].amount;
                            pay.amountInput = pay.checkFields[i].amount;

                            $rootScope.$broadcast('countAmount');
                            break;
                        }
                    }
                }

                if(pay.checkFields){
                    pay.checkFields.forEach(function (product) {
                        if(product.active || !!pay.checkFields && pay.checkFields.length == 1 && pay.service.use_two_step){
                            $rootScope.$broadcast('Counters.selectProduct', product);
                        }
                    });
                }

                pay.innerState = 'create';
                pay.data.preLoader = false;//todo scope

                //remove when fix bank_details
                $timeout(function(){
                    if (step == true) {
                        return pay.createPayment(true);
                    }
                })

            }, function (reason) {
                DateFormater.returnOriginDate();//todo scope
                pay.data.preLoader = false;

                return $translate('NOTIFICATION.ERROR.CHECK_PAYMENT_ERROR').then(function (translation) {
                    pay.apiError(translation);
                });
            });
        },
        createPayment: function (step) {
            if (step === true) {
                pay.data.load = "stepOne"; // TODO: scope
            }

            pay.data.preLoader = true; // TODO: scope

            pay.service.destination = pay.data.manualDestinition ? pay.data.manualDestinition : pay.destinationTemplate; // TODO: scope manualDestinition
            pay.subsidy = pay.subsidyObj.subsidyNum;

            if (pay && pay.checkFields) {
                pay.checkFields.forEach(function (field) {
                    if (field.type === 'GROUP') {
                        field.fields.forEach(function (groupFields) {
                            if (groupFields.alias === 'COUNTER' && groupFields.values && Array.isArray(groupFields.values)) {
                                groupFields.values.forEach(function (value) {
                                    if (value.tariff) {
                                        value.tariff *= 100;
                                    }
                                });
                            }
                        });
                    }
                });
            }

            return PortalApi.createPayment(pay.payment.id, pay).then(function (response) {
                if (response.status !== 'ok') {
                    pay.data.preLoader = false;
                    throw new Error(response);
                }

                pay.createData = {
                    destination: response.destination,
                    account: response.account,
                    mfo: response.mfo,
                    name: response.name,
                    okpo: response.okpo
                };

                // If create did not return receiver requisites, fall back to bank details from the check step
                var bankDetails = findBankDetails(pay.checkFields);
                if (bankDetails) {
                    bankDetails.forEach(function (detail) {
                        if (!pay.createData.name && detail.alias === 'RECEIVER_NAME') {
                            pay.createData.name = detail.value;
                        }
                        if (!pay.createData.account && detail.alias === 'RECEIVER_ACCOUNT') {
                            pay.createData.account = detail.value;
                        }
                        if (!pay.createData.okpo && detail.alias === 'OKPO') {
                            pay.createData.okpo = detail.value;
                        }
                    });
                }

                pay.payment.id = response.id;
                pay.service.commission = response.commission;
                pay.innerState = 'confirm';
                pay.data.preLoader = false; // TODO: scope

                Analytics.addImpression(String(pay.payment.id), pay.info.name);
                Analytics.pageView();

                if (ClientCards.data.card_type === 'masterpass') {
                    $rootScope.$broadcast('changeCardNumber', 'masterpass');
                }

                if (step === true) {
                    pay.confirmPayment(step);
                }

            }).catch(function (error) {
                pay.data.preLoader = false;
                $translate('NOTIFICATION.ERROR.CREATE_PAYMENT_ERROR').then(function (errMsg) {
                    pay.apiError(errMsg,10);
                    console.error(error);
                });
            });
        },
        confirmPayment: function (step) {
            if (step === true) {
                pay.data.load = "stepOne"; // TODO: scope
            }

            pay.data.preLoader = true; // TODO: scope

            if (!Authentication.isLogged) {
                Authentication.user.email = pay.user.email;
            } else {
                var aff_sub = "aff_sub=";
                var decodedCookie = decodeURIComponent(document.cookie);
                var ca = decodedCookie.split(';');
                for (var i = 0; i < ca.length; i++) {
                    var c = ca[i].trim();
                    if (c.indexOf(aff_sub) === 0) {
                        pay.options.salesDoubler = c.substring(aff_sub.length);
                    }
                }
            }

            return PortalApi.confirmPayment(
                pay.payment.id,
                ClientCards.getSourceObj(),
                pay.data.createTemplate,
                pay.user.email || null,
                pay.user.phone,
                pay.options
            ).then(function (response) {
                var payload = (response && response.data && (response.data.status || response.data.error_text))
                    ? response.data
                    : response;
                var status = payload && payload.status;
                var errorText = payload && payload.error_text;

                if (status !== 'ok' || errorText) {
                    pay.data.preLoader = false;

                    if ($rootScope.servicePage) {
                        $state.go('pages.serviceReceipt');
                    } else {
                        $state.go('pages.receipt', {
                            category_id: pay.data.searchServices.category,
                            payment_id: pay.payment.id,
                            category_name: pay.data.categoryName,
                            service_id: pay.data.searchServices.id,
                            service_furl: pay.data.searchServices.furl
                        });
                    }

                    ClientCards.reSetGAPay();

                    if (errorText) {
                        return pay.apiError(errorText, 10);
                    }

                    throw new Error('CONFIRM_PAYMENT_ERROR');
                } else {
                    // The 3dSecure view is switched on by secure3dcheck once the
                    // validation type is known - 3ds2_hidden must stay invisible.
                    ClientCards.reSetGAPay();
                    secure3dPoll.startedAt = Date.now();
                    return pay.secure3dcheck(pay.payment.id);
                }
            }).catch(function (error) {
                pay.data.preLoader = false;
                ClientCards.reSetGAPay();

                $translate('NOTIFICATION.ERROR.' + (error.message || 'UNEXPECTED_ERROR')).then(function (errMsg) {
                    pay.apiError(errMsg, 10);
                    console.error(error);
                });
            });
        },
        apiError: function (errorText, timeSec) {
            pay.data.preLoader = false;//todo scope

            return $translate('NOTIFICATION.ERROR.SERVICE_NOT_FOUND').then(function (translation) {
                Notification.error({
                    message: errorText || translation,
                    delay: timeSec * 1000 || 5000
                });
            });
        },
        toSecure: function () {
            pay.innerState = '3dSecure';
        },
        toCheck: function (isEditCheck) {
            pay.data.counterOfAutocheck++;
            pay.data.showBlock = true;

            pay.data.preLoader = true;
            pay.innerState = 'check';

            ClientCards.data.masterpass = false;
            ClientCards.data.type = '';

            if(!isEditCheck) {
                pay.init();
            }

            DateFormater.takeDate();//todo function to service

            pay.data.preLoader = false;
            pay.selectedProduct.serviceName = '';

        },
        secure3dcheck: function (paymentId) {
            PortalApi.check3Dsecure(paymentId).then(function (res) {
                // Polling is never cancelled: a poll left over from an abandoned
                // payment must not drive the 3DS flow of the next one.
                if (paymentId !== pay.payment.id) {
                    return;
                }

                var errorText = res && (res.error_text || (res.data && res.data.error_text));
                if (errorText) {
                    // Same exit as a declined confirm: the receipt shows the
                    // failed payment instead of an empty 3dSecure panel.
                    stopSecure3d();
                    goToReceipt(paymentId);
                    return pay.apiError(errorText, 10);
                }

                if (['unknown', 'failed'].indexOf(res.transaction) !== -1) {
                    stopSecure3d();

                    if (res.redirect) {
                        return pay.redirectP2Y();
                    }

                    pay.data.preLoader = true;//todo scope
                    return goToReceipt(paymentId);
                }

                if (res.transaction === 'processing') {
                    if (res.lookup) {
                        return $state.go('pages.lookup', {
                            paymentId: pay.payment.id,
                            serviceId: pay.data.serviceId,//todo scope
                            name: pay.data.searchServices.name,//todo scope
                            category: pay.data.searchServices.category,//todo scope
                            furl: pay.data.furl//todo scope
                        });
                    }

                    if (
                        !res.lookup
                        && res.secure3d
                        && Object.keys(res.secure3d).length === 0
                    ) {
                        // scroll position for 3dFrame
                        if (!pay.scrollTop) {
                            pay.scrollTop = true;
                            $anchorScroll(document.body);
                        }
                        //
                        return scheduleSecure3dCheck(paymentId, 2000);
                    }

                    if (
                        res.validationType === '3ds1' &&
                        res.secure3d &&
                        res.secure3d.md &&
                        res.secure3d.ascUrl &&
                        res.secure3d.paReq &&
                        res.secure3d.termUrl
                    ) {

                        if (!pay.secureCard) {

                            pay.data.preLoader = false;//todo scope
                            pay.secureCard = true;
                            pay.toSecure();

                            $rootScope.$broadcast('start3dSecure', res.secure3d);
                        }

                        return scheduleSecure3dCheck(paymentId, 5000);
                    }
                    if(
                        res.validationType !== '3ds1' &&
                        res.secure3d &&
                        res.secure3d.ascUrl &&
                        res.secure3d.termUrl &&
                        res.secure3d.postParams
                    ) {
                        switch (res.validationType) {
                            case '3ds2_hidden':
                                // Invisible 3DS Method step: post the ACS form
                                // into the offscreen 1x1 frame; the secure3d view
                                // shows its own loader, and the panel preLoader
                                // would hide that view together with the form.
                                if (!pay.methodStarted) {
                                    pay.methodStarted = true;
                                    pay.data.preLoader = false;
                                    pay.toSecure();
                                    $anchorScroll('top');
                                    $rootScope.$broadcast('start3dsMethod', res.secure3d);
                                }

                                return scheduleSecure3dCheck(paymentId, 5000);
                            case '3ds2_frame':
                                if (!pay.secureCard) {
                                    pay.secureCard = true;
                                    pay.toSecure();
                                    $rootScope.$broadcast('start3dSecure', res.secure3d);

                                    // keep the panel spinner over the frame while the ACS page loads
                                    $timeout(function () {
                                        pay.data.preLoader = false;
                                    }, 5000);
                                }

                                return scheduleSecure3dCheck(paymentId, 5000);
                            case '3ds2_free':
                            case 'lookup':
                            default:
                                // Frictionless and transient types: keep polling until
                                // 'processed' instead of silently stalling the flow.
                                return scheduleSecure3dCheck(paymentId, 2000);
                        }
                    }

                }

                if (res.transaction === 'processed') {
                    stopSecure3d();
                    pay.data.preLoader = false;//todo scope
                    goToReceipt(paymentId);
                }
            });
        },
        redirectP2Y: function() {
            pay.innerState = "redirect";
            pay.data.serviceId = config.service.pay2you;
            pay.data.redirectData = ClientCards.getSourceObj();

            if (pay.data.redirectData.cardFrom.number) {
                pay.data.redirectData.cardFrom.number = ClientCards.getCardHash(pay.data.redirectData.cardFrom.number);
            }
            if (pay.data.redirectData.cardTo.number) {
                pay.data.redirectData.cardTo.number = ClientCards.getCardHash(pay.data.redirectData.cardTo.number);
            }
            if (pay.data.redirectData.cardFrom.id || pay.data.redirectData.cardTo.id) {
                ClientCards.list.forEach(function (card, i) {
                    if (card.id == pay.data.redirectData.cardFrom.id) {
                        pay.data.redirectData.cardFrom.number = card.number;
                    }
                    if (card.id == pay.data.redirectData.cardTo.id) {
                        pay.data.redirectData.cardTo.number = card.number;
                    }
                });
            }
            $rootScope.$broadcast('countAmount');
        },
        billing: function (paymentId) {
            PortalApi.subscribeToBills(paymentId).then(function (response) {

                if (response.status != 'ok') {
                    return $translate('ERRORS.' + response.text_сode).then(
                        function (text) {
                            pay.apiError(text);
                        },
                        function () {
                            $translate('ERRORS.UNKNOWN_ERROR').then(function (text) {
                                pay.apiError(text, 10);
                            });
                        }
                    );
                }

                $state.go('pages.accounts', {
                    newBillId: 0
                });

            }, function (reason) {
                $translate('ERRORS.' + reason.data.text_сode).then(
                    function (text) {
                        pay.apiError(text);
                    },
                    function () {
                        $translate('ERRORS.UNKNOWN_ERROR').then(function (text) {
                            pay.apiError(text, 10);
                        });
                    }
                );
            });
        },
        phonePaste: function(e) {
            var paste = e.originalEvent.clipboardData.getData('text/plain').replace(/[()\s+\W+]/g, ''),
                cut;
            if (paste.length > 9) {
                cut = paste.substring(paste.length - 9);
                pay.user.phone = cut;
            }
        },
        mobileNmbWidget: function(operator, code) {
            pay.selectedPhone.operator = operator;
            pay.selectedPhone.code = "+380" + code;
            angular.element('.mobile-mnb').children('input').focus();
        },
        addNewServiceHH: function(res) {
            var token = Authentication.getToken();
            var data = {
                hhID: $stateParams.hh.templateId,
                data: {
                    amount: pay.amountInput * 100,
                    name: pay.info.name || pay.data.getService.service.info_text_2 || pay.data.getService.service.name,
                    order_id: pay.payment.order_id,
                    service_id: pay.payment.service_id,
                    fields: pay.fields,
                    shurl: pay.urlCode || null,
                    template_id: null
                }
            };

            PortalApi.addHHTemplate(data, token).then(function(res) {
                $state.go('pages.households', {
                    housholdID: res.household_id
                });
            }, function(err) {
                Localization.notifyTemplate('error', 'NOTIFICATION.ERROR.OOPS_ERROR', 5, true);
                $state.go('pages.households', {
                    housholdID: $stateParams.hh.templateId
                });

            });
        },
        getMaxAmount: function (categoryId, serviceId) {
            var limit29999 = [13062, 29, 32, 34, 38, 39, 40, 42, 44, 45, 46, 47, 48, 49, 50, 51];
            var limit399999 = [37];

            if (limit29999.includes(categoryId) || limit29999.includes(serviceId)) {
                return '29999.99';
            } else if (limit399999.includes(categoryId) || limit399999.includes(serviceId)) {
                return '399999.99';
            } else {
                return pay.selectedProduct.maxAmount || pay.service.amount_max;
            }
        }
    };

    return pay;
}

angular.module('user-payment', [])
    .service('Pay', Pay);

Pay.$inject = ['$state', 'configs', '$rootScope', '$timeout', 'PortalApi', 'Authentication', '$stateParams', 'uibDatepickerConfig', '$location', '$translate', 'Notification', 'Analytics', 'ClientCards', 'DateFormater', '$anchorScroll', 'Localization', '$q'];



/*****************
 ** WEBPACK FOOTER
 ** ./app/components/user-payment/services/user-payment.js
 ** module id = 119
 ** module chunks = 1
 **/